import styled from 'styled-components';

export const Svg = styled.svg`
  transition: all 0.2s ease-in-out;

  & > * {
    transition: all 0.2s ease-in-out;
  }
`;
